import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import AssignBlock, { OnChangeProps } from '~/components/AssignBlock';
import Button from '~/components/Button';
import JustificationContainer from '~/components/JustificationContainer';
import { Heading5, Variant } from '~/components/Typography/index';

export type Props = {
  dataTestId?: string;
  onSave: (update: OnChangeProps) => void;
  loading?: boolean;
} & OnChangeProps;

const AssignContactWithSave: React.FC<Props> = ({
  dataTestId,
  userId,
  officeId,
  onSave,
  loading = false,
  ...rest
}) => {
  const [update, setUpdate] = useState<OnChangeProps>({ userId, officeId });
  return (
    <>
      <Heading5 withoutMargin variant={Variant.primary}>
        Contacten toewijzen aan:
      </Heading5>
      <JustificationContainer
        justification="space-between"
        align="center"
        data-testid={dataTestId}
        {...rest}
      >
        <Inner>
          <AssignBlock
            userId={update.userId}
            officeId={update.officeId}
            onChange={change => setUpdate(change)}
          />
        </Inner>
        <Button
          size="medium"
          label="Klaar"
          onClick={() => onSave(update)}
          appearance="secondary"
          icon="check"
          loading={loading}
          disabled={update.userId === userId && update.officeId === officeId}
        />
      </JustificationContainer>
    </>
  );
};

const Inner = styled.div<{}>(
  ({ theme }) => css`
    margin-right: ${theme.space('s')};
    width: 100%;
  `,
);

export default AssignContactWithSave;
